import type { BriefingReportPageData } from "content-ui/briefings/fetchers/briefingReportFetcher";

import Heading from "content-ui/briefings/components/briefingsReports/elements/heading";
import CardContainer from "content-ui/briefings/components/briefingsReports/elements/cardContainer";
import Table from "content-ui/briefings/components/briefingsReports/elements/table/table";

const StartupsTableCard = ({
  briefing,
  id,
}: {
  briefing: BriefingReportPageData;
  id: string;
}) => {
  return (
    <CardContainer
      id={id}
      innerClassNames="max-w-[100%] w-[calc(100vw-42px)] md:w-[calc(100vw-68px)]"
    >
      <Heading text={briefing.startupsHeading} id={id} />
      <Table briefing={briefing} />
    </CardContainer>
  );
};

export default StartupsTableCard;
